import Pages from "@/pages/index.jsx"
import { Toaster } from "@/components/ui/toaster"

/**
 * Hauptkomponente der Anwendung
 * Rendert die Seiten und den Toast-Container für Benachrichtigungen
 * 
 * Diese Komponente ist der oberste Container der Anwendung und
 * verwaltet das grundlegende Layout und die Toast-Benachrichtigungen
 */
function App() {
  return (
    <>
      <Pages />
      <Toaster />
    </>
  )
}

export default App 